<template>
  <div id="shop">
    <div class="shop-box">
      <img src="../../../assets/image/shop1.jpg" alt="">
      <img src="../../../assets/image/shop2.jpg" alt="">
    </div>
    <div class="shop-box" style="margin-bottom: 40px">
      <h3 class="title">门店分布</h3>
      <div class="table-header line">
        <span class="lf">城市</span>
        <span class="texts">店铺名称</span>
      </div>
      <div class="line">
                <span class="lf">北京海淀区（6家）</span>
                <span
                    class="rg">清河万象汇店、金源时代购物中心店、西直门枫蓝国际中心店、西三旗万象汇店、五棵松万达店、海淀大悦城店</span>
              </div>
              <div class="table-tr line">
                <span class="lf">北京经济开发区（3家）</span>
                <span class="rg">大兴瀛海环宇坊店、亦庄龙湖天街店、旧宫住总万科广场店</span>
              </div>
              <div class="line">
                <span class="lf">北京朝阳区（8家）</span>
                <span class="rg">凯德MALL太阳宫店、蓝色港湾店、双井九龙汇合生创展店、长楹龙湖天街店、北京城悦荟店、东坝万达店、朝阳大悦城店、华堂新辰汇店</span>
              </div>
              <div class="table-tr line">
                <span class="lf">北京通州区（4家）</span>
                <span class="rg">通州领展购物广场店、通州苏宁百货店、湾里王府井welltown店、通州爱琴海店</span>
              </div>
              <!--      <div class="line">-->
              <!--        <span class="lf">北京西城区（1家）</span>-->
              <!--        <span class="rg"></span>-->
              <!--      </div>-->
              <div class="line">
                <span class="lf">北京丰台区（4家）</span>
                <span class="rg">大红门银泰店、万丰和谐广场店、槐房万达店、凯德MALL大峡谷店</span>
              </div>
              <div class="table-tr line">
                <span class="lf">北京大兴区（7家）</span>
                <span class="rg">高米店绿地店、大兴宜家荟聚中心店、大兴宜家荟聚购物中心精品店、大兴龙湖天街店、凯德MALL大兴店、大兴新辰天地店、丽家丽婴生活馆</span>
              </div>
              <div class="line">
                <span class="lf">北京昌平区（4家）</span>
                <span class="rg">昌平悦荟万科店、天通苑龙德广场店、北京超极合生汇店、昌平区平西府小站公园店</span>
              </div>
              <div class="table-tr line">
                <span class="lf">北京石景山区（1家）</span>
                <span class="rg">石景山喜隆多店</span>
              </div>
              <div class="line">
                <span class="lf">北京房山区（3家）</span>
                <span class="rg">长阳绿地店、龙湖房山天街店、良乡大学城店</span>
              </div>
              <div class="table-tr line">
                <span class="lf">北京顺义区（2家）</span>
                <span class="rg">顺义中粮祥云店、北京顺义隆华购物中心店</span>
              </div>
              <!--      <div class="table-tr line">-->
              <!--        <span class="lf">北京门头沟区（1家）</span>-->
              <!--        <span class="rg"></span>-->
              <!--      </div>-->
              <div class="line">
                <span class="lf">河北（2家）</span>
                <span class="rg">燕郊永旺梦乐城店、燕郊明润广场店</span>
              </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
#shop {
  width: 100%;

  .shop-box {
    padding: 0 110px 15px 110px;

    img {
      width: 100%;
      height: 100%;
      margin-top: 20px;
    }

    .title {
      text-align: center;
      height: 80px;
      line-height: 80px;
      font-size: 30px;
      color: #908794;
      margin-bottom: 15px;
    }

    .table-header {
      font-size: 22px;
      background: #DBD7D8;
    }

    .table-tr {
      background: #E6E6E6;
    }

    .line {
      height: 70px;
      line-height: 70px;
      display: flex;
      align-items: center;
      color: #908794;
      padding: 10px 0;
      font-size: 16px;

      .lf {
        width: 180px;
        flex: none;
        padding-left: 25px;
        font-weight: 600;
        letter-spacing: 0.5px;
      }

      .rg {
        line-height: 24px;
        width: 80%;
      }

      .texts {
        font-weight: 600;
        letter-spacing: 0.5px;
      }
    }
  }
}
</style>
